module.exports = __webpack_public_path__ + "static/media/sbs.36343d4e.png";